/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_Dev_BudgetInputs */

const en_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learning & development budget`)
};

const de_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiterbildungsbudget`)
};

const fr_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget formation et développement`)
};

const es_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presupuesto de formación y desarrollo`)
};

const it_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget per formazione e sviluppo`)
};

const nl_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opleidings- en ontwikkelingsbudget`)
};

const pl_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budżet na szkolenia i rozwój`)
};

const fi_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppimis- ja kehitysbudjetti`)
};

const da_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uddannelses- og udviklingsbudget`)
};

const sv_salary_negotiate_other_dev_budget = /** @type {(inputs: Salary_Negotiate_Other_Dev_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utbildnings- och utvecklingsbudget`)
};

/**
* | output |
* | --- |
* | "Learning & development budget" |
*
* @param {Salary_Negotiate_Other_Dev_BudgetInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_dev_budget = /** @type {((inputs?: Salary_Negotiate_Other_Dev_BudgetInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_Dev_BudgetInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_dev_budget(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_dev_budget(inputs)
	if (locale === "es") return es_salary_negotiate_other_dev_budget(inputs)
	if (locale === "it") return it_salary_negotiate_other_dev_budget(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_dev_budget(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_dev_budget(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_dev_budget(inputs)
	if (locale === "da") return da_salary_negotiate_other_dev_budget(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_dev_budget(inputs)
	return en_salary_negotiate_other_dev_budget(inputs)
});